import { React } from "mondrian-react";
import Footer from "components/Footer";
import Loading from "components/Loading";
import Topbar from "components/Topbar";
import AccessbilityBar from "components/AccessibilityBar";
import AlertPWA from 'components/AlertPWA';
import useIsTotem from "hooks/useIsTotem";

const PageContainer = ({ children, isLoading }) => {
  const isTotem = useIsTotem();

  return (
    <>
      {!isTotem && 
        <>
          <Topbar />
          <AccessbilityBar />
        </>
      }

      {/iPad|iPhone|iPod/.test(window?.navigator?.userAgent)
        || isTotem
        ? null 
        : <AlertPWA />
      }

      <main id="content" className={"mdn-Container"}>
        {isLoading ? <Loading /> : children && children}
      </main>

      {!isTotem && <Footer />}
    </>
  );
};

export default PageContainer;
